import React from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import LanguageSetup from './components/LanguageSetup';
import TranslatePage from './pages/TranslatePage';

const App: React.FC = () => {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<LanguageSetup />} />
        <Route path="/translate" element={<TranslatePage />} />
      </Routes>
    </div>
  );
}

export default App;
